import { FeatureTree } from './feature-tree';
import { FeatureStatus } from '@otto-ec/tracking-bct';
import { DomData } from './dom-data';
import { Component } from '../component';

export class ContentTracking extends Component {
    private richContentElement: HTMLElement | null = null;
    private visibilityTrackingDone = false;
    private isInitialVariationChange = true;

    public variationChanged() {
        this.richContentElement = document.querySelector<HTMLElement>('.js_rc_component');
        if (this.richContentElement) {
            if (this.isInitialVariationChange) {
                this.registerVisibilityTrackingListener();
                // Only track the initial variation change
                this.trackPageImpression();
                this.isInitialVariationChange = false;
            }
        }
    }

    private registerVisibilityTrackingListener(): void {
        const relevantEvents = ['scroll', 'resize'];
        relevantEvents.forEach((type) => {
            addEventListener(type, () => this.trackRichContentVisibleIfRequired(), false);
        });
    }

    private trackPageImpression(): void {
        const featureTree = FeatureTree.createRoot('rc-pi', 'RichContent', 'loaded', {});

        this.addWinnerProviderAndModules(featureTree, 'loaded');

        const otherProviderNames = DomData.getOtherProviderNames();
        otherProviderNames.forEach((name) => {
            this.addProvider(featureTree, name, 'hidden');
        });

        this.trackView({}, featureTree.toArray());
    }

    private trackRichContentVisibleIfRequired(): void {
        if (!this.visibilityTrackingDone && this.isRichContentVisible()) {
            this.trackRichContentVisible();
            this.visibilityTrackingDone = true;
        }
    }

    trackRichContentVisible(): void {
        const trackingFeature = FeatureTree.createRoot('rc-scrl', 'RichContent', 'visible', {});

        this.addWinnerProviderAndModules(trackingFeature, 'visible');

        //use 'scroll' for resize too
        this.trackEvent(
            {},
            {
                name: 'scroll',
                features: trackingFeature.toArray(),
            }
        );
    }

    private addWinnerProviderAndModules(parent: FeatureTree, status: FeatureStatus): FeatureTree {
        const provider = this.addProvider(parent, DomData.getProviderName(), status);
        for (let i = 0; i < DomData.getModuleCount(); i++) {
            this.addModule(provider, status);
        }
        return provider;
    }

    private addProvider(parent: FeatureTree, name: string, status: FeatureStatus): FeatureTree {
        return parent.addChild('p', 'RichContent-Provider', status, { product_RichContentProvider: [name] });
    }

    private addModule(parent: FeatureTree, status: FeatureStatus): FeatureTree {
        return parent.addChild('m', 'RichContent-Modul', status, {});
    }

    isRichContentVisible(): boolean {
        if (!this.richContentElement) return false;
        const contentContainerTop = this.richContentElement.getBoundingClientRect().top;
        // if a div is invisible, the bounding client rect is always {0, 0, 0, 0}
        if (0 === contentContainerTop) {
            return false;
        }
        const viewportHeight = document.documentElement.clientHeight;
        const visibleHeight = viewportHeight - contentContainerTop;
        return visibleHeight > 100;
    }
}
